import * as Yup from 'yup';
import { validationSchema } from 'utils/validations';
import { REQUIRED_ID_NUMBER_FIELD } from 'routes/preScore/contants';

export const AMOUNT_DEFAULT = 40;
export const TENOR_DDEFAULT = 27;

export const searchValidation = Yup.object().shape({
  phoneNumber: validationSchema.phoneNumber,
  idCard: Yup.string()
    .required(REQUIRED_ID_NUMBER_FIELD)
    .test(
      'len',
      'Số CCCD / Căn cước không hợp lệ',
      val => val && (val.length === 9 || val.length === 12),
    ),
});

export const validatePhone = Yup.object().shape({
  phoneNumber: validationSchema.phoneNumber,
});

export function formatMoney(
  amount,
  decimalCount = 0,
  decimal = '.',
  thousands = ',',
) {
  let abcDecimalCount = Math.abs(decimalCount);
  abcDecimalCount = Number.isNaN(abcDecimalCount) ? 2 : abcDecimalCount;

  const negativeSign = amount < 0 ? '-' : '';
  const absAmount = Math.abs(Number(amount) || 0);

  const i = parseInt(absAmount.toFixed(abcDecimalCount), 10).toString();
  const j = i.length > 3 ? i.length % 3 : 0;

  return (
    negativeSign +
    (j ? i.substr(0, j) + thousands : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) +
    (abcDecimalCount
      ? decimal +
        Math.abs(absAmount - i)
          .toFixed(abcDecimalCount)
          .slice(2)
      : '')
  );
}

// Don't use installment anymore, import the formula in utils instead
export const LIST_AMOUNT = {
  // '5': [
  //   {
  //     tenor: 3,
  //     installment: 1713185,
  //   },
  //   {
  //     tenor: 6,
  //     installment: 874316,
  //   },
  // ],
  '10': [
    // {
    //   tenor: 3,
    //   installment: 3426370,
    // },
    {
      tenor: 6,
      installment: 1748633,
    },
    {
      tenor: 9,
      installment: 1189706,
    },
    {
      tenor: 12,
      installment: 935944,
    },
    {
      tenor: 15,
      installment: 768584,
    },
  ],
  '15': [
    // {
    //   tenor: 3,
    //   installment: 5139555,
    // },
    {
      tenor: 6,
      installment: 2622949,
    },
    {
      tenor: 9,
      installment: 1784559,
    },
    {
      tenor: 12,
      installment: 1403916,
    },
    {
      tenor: 15,
      installment: 1152876,
    },
    {
      tenor: 18,
      installment: 985930,
    },
    {
      tenor: 21,
      installment: 867035,
    },
    {
      tenor: 24,
      installment: 778172,
    },
  ],
  '20': [
    {
      tenor: 6,
      installment: 3497266,
    },
    {
      tenor: 9,
      installment: 2379413,
    },
    {
      tenor: 12,
      installment: 1871888,
    },
    {
      tenor: 15,
      installment: 1537168,
    },
    {
      tenor: 18,
      installment: 1314573,
    },
    {
      tenor: 21,
      installment: 1156047,
    },
    {
      tenor: 24,
      installment: 1037563,
    },
    {
      tenor: 27,
      installment: 945772,
    },
    {
      tenor: 30,
      installment: 872664,
    },
    {
      tenor: 33,
      installment: 813143,
    },
    {
      tenor: 36,
      installment: 763809,
    },
  ],
  '40': [
    {
      tenor: 12,
      installment: 3743775,
    },
    {
      tenor: 15,
      installment: 3074337,
    },
    {
      tenor: 18,
      installment: 2629146,
    },
    {
      tenor: 21,
      installment: 2312094,
    },
    {
      tenor: 24,
      installment: 2075126,
    },
    {
      tenor: 27,
      installment: 1891544,
    },
    {
      tenor: 30,
      installment: 1745328,
    },
    {
      tenor: 33,
      installment: 1626285,
    },
    {
      tenor: 36,
      installment: 1527618,
    },
    {
      tenor: 39,
      installment: 1444622,
    },
    {
      tenor: 42,
      installment: 1373934,
    },
    {
      tenor: 45,
      installment: 1313091,
    },
    {
      tenor: 48,
      installment: 1260243,
    },
    {
      tenor: 51,
      installment: 1099897,
    },
    {
      tenor: 54,
      installment: 1057889,
    },
    {
      tenor: 57,
      installment: 1020494,
    },
  ],
  '60': [
    {
      tenor: 12,
      installment: 5615663,
    },
    {
      tenor: 15,
      installment: 4611505,
    },
    {
      tenor: 18,
      installment: 3943719,
    },
    {
      tenor: 21,
      installment: 3468142,
    },
    {
      tenor: 24,
      installment: 3112689,
    },
    {
      tenor: 27,
      installment: 2837316,
    },
    {
      tenor: 30,
      installment: 2617992,
    },
    {
      tenor: 33,
      installment: 2439428,
    },
    {
      tenor: 36,
      installment: 2291427,
    },
    {
      tenor: 39,
      installment: 2166933,
    },
    {
      tenor: 42,
      installment: 2060902,
    },
    {
      tenor: 45,
      installment: 1969637,
    },
    {
      tenor: 48,
      installment: 1890365,
    },
    {
      tenor: 51,
      installment: 1649846,
    },
    {
      tenor: 54,
      installment: 1586834,
    },
    {
      tenor: 57,
      installment: 1530742,
    },
  ],
  '80': [
    {
      tenor: 15,
      installment: 6148673,
    },
    {
      tenor: 18,
      installment: 5258292,
    },
    {
      tenor: 21,
      installment: 4624189,
    },
    {
      tenor: 24,
      installment: 4150252,
    },
    {
      tenor: 27,
      installment: 3783088,
    },
    {
      tenor: 30,
      installment: 3490656,
    },
    {
      tenor: 33,
      installment: 3252570,
    },
    {
      tenor: 36,
      installment: 3055236,
    },
    {
      tenor: 39,
      installment: 2889243,
    },
    {
      tenor: 42,
      installment: 2747869,
    },
    {
      tenor: 45,
      installment: 2626183,
    },
    {
      tenor: 48,
      installment: 2520486,
    },
    {
      tenor: 51,
      installment: 2199794,
    },
    {
      tenor: 54,
      installment: 2115779,
    },
    {
      tenor: 57,
      installment: 2040989,
    },
  ],
  '100': [
    {
      tenor: 18,
      installment: 6572865,
    },
    {
      tenor: 21,
      installment: 5780236,
    },
    {
      tenor: 24,
      installment: 5187815,
    },
    {
      tenor: 27,
      installment: 4728860,
    },
    {
      tenor: 30,
      installment: 4363321,
    },
    {
      tenor: 33,
      installment: 4065713,
    },
    {
      tenor: 36,
      installment: 3819045,
    },
    {
      tenor: 39,
      installment: 3611554,
    },
    {
      tenor: 42,
      installment: 3434836,
    },
    {
      tenor: 45,
      installment: 3282728,
    },
    {
      tenor: 48,
      installment: 3150608,
    },
    {
      tenor: 51,
      installment: 2749743,
    },
    {
      tenor: 54,
      installment: 2644724,
    },
    {
      tenor: 57,
      installment: 2551236,
    },
  ],
  '120': [
    {
      tenor: 21,
      installment: 6601878,
    },
    {
      tenor: 24,
      installment: 5888195,
    },
    {
      tenor: 27,
      installment: 5334306,
    },
    {
      tenor: 30,
      installment: 4892269,
    },
    {
      tenor: 33,
      installment: 4531577,
    },
    {
      tenor: 36,
      installment: 4231889,
    },
    {
      tenor: 39,
      installment: 3979126,
    },
    {
      tenor: 42,
      installment: 3763228,
    },
    {
      tenor: 45,
      installment: 3576820,
    },
    {
      tenor: 48,
      installment: 3414370,
    },
    {
      tenor: 51,
      installment: 3271645,
    },
    {
      tenor: 54,
      installment: 3145357,
    },
    {
      tenor: 57,
      installment: 3032905,
    },
  ],
  '140': [
    {
      tenor: 24,
      installment: 6869561,
    },
    {
      tenor: 27,
      installment: 6223357,
    },
    {
      tenor: 30,
      installment: 5707647,
    },
    {
      tenor: 33,
      installment: 5286839,
    },
    {
      tenor: 36,
      installment: 4937204,
    },
    {
      tenor: 39,
      installment: 4642314,
    },
    {
      tenor: 42,
      installment: 4390433,
    },
    {
      tenor: 45,
      installment: 4172957,
    },
    {
      tenor: 48,
      installment: 3983431,
    },
    {
      tenor: 51,
      installment: 3816920,
    },
    {
      tenor: 54,
      installment: 3669583,
    },
    {
      tenor: 57,
      installment: 3538389,
    },
  ],
  '160': [
    {
      tenor: 27,
      installment: 7112408,
    },
    {
      tenor: 30,
      installment: 6523026,
    },
    {
      tenor: 33,
      installment: 6042102,
    },
    {
      tenor: 36,
      installment: 5642519,
    },
    {
      tenor: 39,
      installment: 5305501,
    },
    {
      tenor: 42,
      installment: 5017638,
    },
    {
      tenor: 45,
      installment: 4769094,
    },
    {
      tenor: 48,
      installment: 4552493,
    },
    {
      tenor: 51,
      installment: 4362194,
    },
    {
      tenor: 54,
      installment: 4193809,
    },
    {
      tenor: 57,
      installment: 4043874,
    },
  ],
  '180': [
    {
      tenor: 30,
      installment: 7338404,
    },
    {
      tenor: 33,
      installment: 6797365,
    },
    {
      tenor: 36,
      installment: 6347834,
    },
    {
      tenor: 39,
      installment: 5968689,
    },
    {
      tenor: 42,
      installment: 5644843,
    },
    {
      tenor: 45,
      installment: 5365231,
    },
    {
      tenor: 48,
      installment: 5121555,
    },
    {
      tenor: 51,
      installment: 4907468,
    },
    {
      tenor: 54,
      installment: 4718035,
    },
    {
      tenor: 57,
      installment: 4549358,
    },
  ],
  '200': [
    {
      tenor: 33,
      installment: 7552628,
    },
    {
      tenor: 36,
      installment: 7053149,
    },
    {
      tenor: 39,
      installment: 6631877,
    },
    {
      tenor: 42,
      installment: 6272047,
    },
    {
      tenor: 45,
      installment: 5961367,
    },
    {
      tenor: 48,
      installment: 5690616,
    },
    {
      tenor: 51,
      installment: 5452742,
    },
    {
      tenor: 54,
      installment: 5242261,
    },
    {
      tenor: 57,
      installment: 5054842,
    },
  ],
};
